import { connect } from 'react-redux';
import { stepDialogSave, stepDialogClose } from '../../actions';
import StepDialog from './StepDialog';

const mapStateToProps = ({ stepDialog }) => {
    return {
        step: stepDialog.step,
        open: stepDialog.open,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onClose: () => {
        dispatch(stepDialogClose());
    },
    onSave: (currStep) => {
        dispatch(stepDialogSave({ currStep }));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(StepDialog);
